export default "__VITE_ASSET__CuMsse7B__"